import step1 from "../images/instructions/IMAGE 1.png";
import step2 from "../images/instructions/IMAGE 2.png";
import step3 from "../images/instructions/IMAGE 3.png";
import step4 from "../images/instructions/IMAGE 4.png";
import step5 from "../images/instructions/IMAGE 5.png";
import step6 from "../images/instructions/IMAGE 6.png";
import step7 from "../images/instructions/IMAGE 7.png";

export const demoHero = {
  title: "How it works",
  subtitle: "Everything is built in at the station — just follow these steps",
};

export const demoSteps = [
  {
    image: step1,
    title: "Get started",
    description: "Secure your dog in the tub and pay at the station to begin.",
    duration: null,
    alt: "Our Facilities",
  },
  {
    image: step2,
    title: "Shampoo",
    description: "Select Shampoo and work it through the coat by hand.",
    duration: "1–2 min",
    alt: "Shampoo",
  },
  {
    image: step3,
    title: "Warm rinse",
    description: "Rinse thoroughly with warm water.",
    duration: "1–2 min",
    alt: "Warm Rinse",
  },
  {
    image: step4,
    title: "Conditioner",
    description: "Apply Conditioner for a healthy coat.",
    duration: "1–2 min",
    alt: "Conditioner",
  },
  {
    image: step5,
    title: "Anti-flea rinse",
    description:
      "Rinse with Anti-Flea Shampoo for flea control (leave in).",
    duration: "30–60 sec",
    alt: "Anti-Flea Shampoo",
  },
  {
    image: step6,
    title: "Blow dry",
    description: "Blow dry the coat on low or high setting.",
    duration: "~5 min",
    alt: "Blow Dry",
  },
  {
    image: step7,
    title: "Clean up",
    description: "Take your dog out and rinse the tub for the next user.",
    duration: "30–60 sec",
    alt: "Disinfect Tub",
  },
];

export const demoMeta = {
  title: "How It Works | Pawwash",
  description:
    "Step-by-step guide to using a Pawwash self-serve dog wash station — shampoo, rinse, blow dry, and disinfect in about 10 minutes.",
  path: "/demo",
};
